import type { Orientation } from '../../../../../core/types/orientation.js';
import { LEGEND_POSITION } from '../../../constants.js';
import type { LegendPosition } from '../../../types/legend.js';
import { ORIENTATION } from '../types/constants.js';

const LEGEND_MIN_WIDTH = 225;

/**
 * Calculates the legend orientation if its position its auto
 * @param width - Represents the parent container width
 * @param height - Represents the parent container height
 * @returns - The legend orientation
 */
const calculateAutoOrientation = (width: number, height: number) => {
  if (width > height + LEGEND_MIN_WIDTH) {
    return ORIENTATION.Horizontal;
  }

  return ORIENTATION.Vertical;
};

/**
 * Calculates the legend orientation depending of its position
 * @param position - The place the customer wants to put the legend could be one of those: bottom, right, or auto
 * @param width - Represents the parent container width
 * @param height - Represents the parent container height
 * @returns - The legend orientation
 */
export const getOrientation = (
  width: number,
  height: number,
  position?: LegendPosition,
) => {
  if (position === LEGEND_POSITION.Bottom) {
    return ORIENTATION.Vertical;
  }

  if (position === LEGEND_POSITION.Right) {
    return ORIENTATION.Horizontal;
  }

  return calculateAutoOrientation(width, height);
};

export const isVertical = (orientation: Orientation) =>
  orientation === ORIENTATION.Vertical;

/**
 * Returns the orientation of the legend based in the orientation of the layout.
 * @internal
 */
export const getLegendOrientation = (layoutOrientation: Orientation) =>
  isVertical(layoutOrientation) ? ORIENTATION.Horizontal : ORIENTATION.Vertical;
